import React from 'react';

// The server supplies retained placement evidence, not permission to resume.
// Never turn a future date or an inactive account into an activation promise.
export default function PlannedEmployment({ employee, title = true }) {
  const planned = employee.plannedEmployment;
  if (employee.isActive !== false || employee.lifecycleStatus !== 'placed' || !planned) return null;
  return <div style={{ fontSize: '0.78rem', marginTop: 4, whiteSpace: 'normal' }}>
    {title && <strong>Planned employment · access off</strong>}
    <div>Planned from {planned.startDate}{planned.endDate ? ` to ${planned.endDate}` : ''}</div>
    {planned.customerName && <div>{planned.customerName}</div>}
    <div>Access remains off. Activation requires current eligibility confirmation.</div>
  </div>;
}
